import React from 'react';
import {Button} from "antd";
import { StyledModal } from './StyledModal';

type RegistrationIsRequiredProps = {
    isOpen: boolean,
    close: () => void
}

export const RegistrationIsRequired = ({isOpen, close} : RegistrationIsRequiredProps) => {

    const loginHandler = () => {
        window.open('/');
    }

    const registrationHandler = () => {
        window.open('https://t.me/rtsim_career/315', '_blank');
    }

    return(
        <StyledModal 
            title="Вы не вошли в систему" 
            open={isOpen}
            footer={[
                <Button type="text" onClick={close} style={{marginRight: '6px', float: 'left'}} key="back">
                    Отмена
                </Button>,
                <Button onClick={loginHandler} key="login">
                    Войти
                </Button>,
                <Button type="primary" onClick={registrationHandler} key="register">
                    Зарегистрироваться
                </Button>
            ]}
            onCancel={close}
        >
            <p> Доступ к корталу доступен только для пользователей ПО &quot;РТСИМ.Карьера&quot; </p>
        </StyledModal>
    )
}